import { useState } from "react";
import { CustomRoutes, Layout, Menu, defaultTheme, AppBar, TitlePortal, RefreshIconButton, } from "react-admin";
import { Navigate, Route } from "react-router-dom";
import { Box } from '@mui/material';

import users from "./pages/users";
import reports from "./pages/reports";
import invitations from "./pages/invitations";
import organisations from "./pages/organisations";
import teams from "./pages/teams";
import vetCases from "./pages/vetcases";
import horses from "./pages/horses";
import visionAppPdfRequests from "./pages/visionapppdfrequests";

import {
  HydraAdmin,
  useIntrospection,
  ResourceGuesser
} from "@api-platform/admin";

import authProvider from "./utils/authProvider";
import dataProvider from "./utils/dataProvider";
import LoginPage from "./LoginPage";

const RedirectToLogin = () => {
  const introspect = useIntrospection();

  if (localStorage.getItem("token")) {
    introspect();
    return <></>;
  }
  return <Navigate to="/login" />;
};

const CustomMenu = () => (
  <Menu>
    <Menu.ResourceItem name="users" />
    <Menu.ResourceItem name="vision_app_pdf_requests" />
  </Menu>
);

const theme = {
  ...defaultTheme,
  palette: {
    primary: {
      main: '#3E85A7',
    }
  },
};
const MyAppBar = () => (
  <AppBar color="primary" toolbar={<><RefreshIconButton /> </>}>
    <TitlePortal />
    <Box flex="1" />
    <span>Dashboard Vet Back Office</span>
    <Box flex="1" />
  </AppBar>
);

const CustomLayout = props => (
  <>
    <Layout {...props} appBar={MyAppBar} menu={CustomMenu} />
  </>
);

const App = () => {
  const [redirectToLogin, setRedirectToLogin] = useState(false);


  return <HydraAdmin
    loginPage={LoginPage}
    dataProvider={dataProvider(setRedirectToLogin)}
    authProvider={authProvider}
    theme={theme}
    darkTheme={null}
    layout={CustomLayout}
    entrypoint={process.env.REACT_APP_ENTRYPOINT}>

    <ResourceGuesser options={{ label: 'Users' }} name="users" {...users} />
    <ResourceGuesser options={{ label: 'Invitations' }} name="user_invites" {...invitations} />
    <ResourceGuesser options={{ label: 'Reports' }} name="reports" {...reports} />
    <ResourceGuesser options={{ label: 'Vet cases' }} name="vet_cases" {...vetCases} />
    <ResourceGuesser options={{ label: 'Organisations' }} name="organisations" {...organisations} />
    <ResourceGuesser options={{ label: 'Teams' }} name="teams" {...teams} />
    <ResourceGuesser options={{ label: 'Horses' }} name="horses" {...horses} />
    <ResourceGuesser options={{ label: 'Vision PDF requests' }} name="vision_app_pdf_requests" {...visionAppPdfRequests} />

    <CustomRoutes>
      {redirectToLogin ? <Route path="/" element={<RedirectToLogin />} /> : null}
    </CustomRoutes>
  </HydraAdmin>
};

export default App;
